import React, { useEffect, useState } from "react";
import AdminNavbar from "../../../components/admin_navbar";
import AdminSideMenu from "../../../components/admin_side_menu";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "bulma-pagination-react";

const CreditNotes = () => {
  const navigate = useNavigate();
  var apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [invoices, setCreditNotes] = useState([]);
  const [per, setPer] = useState(8);
  const [pageCount, setPageCount] = useState(1);

  // Keyset pagination state
  const [nextCursor, setNextCursor] = useState(null);
  const [prevCursor, setPrevCursor] = useState(null);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);
  const [currentCursor, setCurrentCursor] = useState(null);

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    window.scrollTo(0, 0);
    setCurrentPage(1);

    const currentDate = new Date();
    const previousDay = new Date(currentDate);
    previousDay.setDate(currentDate.getDate() - 1);

    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);

    setStartDate(previousDay);
    setEndDate(nextDay);

    var url =
      apiBaseURL +
      "/invoices?document_type=credit_note&per=" +
      per +
      "&use_keyset_paging=true";

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let invoicesData = JSON.parse(JSON.stringify(response.data));
        let invoicesCount = invoicesData.pagination.count;
        setCount(invoicesCount);
        setCreditNotes(invoicesData.invoices);

        // Update keyset pagination state
        setNextCursor(invoicesData.next_cursor);
        setPrevCursor(invoicesData.prev_cursor);
        setHasNext(invoicesData.has_next);
        setHasPrev(invoicesData.has_prev);
        setCurrentCursor(null);

        let numPages = Math.ceil(invoicesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("fetchCreditNotes err = " + err.message));
  }, [apiBaseURL, per, navigate]);

  const searchCreditNotes = (searchTermText) => {
    setSearchTerm(searchTermText);
    var accessToken = localStorage.getItem("strutspos_access_token");
    var url =
      apiBaseURL +
      "/invoices?document_type=credit_note&search=" +
      searchTermText +
      "&use_keyset_paging=true&per=" +
      per;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let invoicesData = JSON.parse(JSON.stringify(response.data));
        let invoicesCount = invoicesData.pagination.count;
        setCount(invoicesCount);
        setCreditNotes(invoicesData.invoices);

        // Reset keyset pagination for search
        setNextCursor(invoicesData.next_cursor);
        setPrevCursor(invoicesData.prev_cursor);
        setHasNext(invoicesData.has_next);
        setHasPrev(invoicesData.has_prev);
        setCurrentCursor(null);
        setCurrentPage(1);

        let numPages = Math.ceil(invoicesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("searchCreditNotes err = " + err.message));
  };

  const handlePageClick = (direction) => {
    if (direction === "next" && hasNext) {
      filterCreditNotesKeyset("next", nextCursor);
    } else if (direction === "prev" && hasPrev) {
      filterCreditNotesKeyset("prev", prevCursor);
    }
  };

  const filterCreditNotesKeyset = (direction, cursorId) => {
    var accessToken = localStorage.getItem("strutspos_access_token");

    var url =
      apiBaseURL +
      "/invoices?document_type=credit_note&per=" +
      per +
      "&use_keyset_paging=true" +
      "&cursor_direction=" +
      direction +
      "&cursor_id=" +
      cursorId;

    // Add search term if exists
    if (searchTerm) {
      url += "&search=" + searchTerm;
    }

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let invoicesData = JSON.parse(JSON.stringify(response.data));
        let invoicesCount = invoicesData.pagination.count;
        setCount(invoicesCount);
        setCreditNotes(invoicesData.invoices);

        // Update keyset pagination state
        setNextCursor(invoicesData.next_cursor);
        setPrevCursor(invoicesData.prev_cursor);
        setHasNext(invoicesData.has_next);
        setHasPrev(invoicesData.has_prev);
        setCurrentCursor(cursorId);

        // Update page counter for display
        if (direction === "next") {
          setCurrentPage(currentPage + 1);
        } else if (direction === "prev") {
          setCurrentPage(Math.max(1, currentPage - 1));
        }

        let numPages = Math.ceil(invoicesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("filter CreditNotes err = " + err.message));
  };

  const dateFilterCreditNotes = (dateStart, dateEnd) => {
    var accessToken = localStorage.getItem("strutspos_access_token");

    var url =
      apiBaseURL +
      "/invoices?document_type=credit_note&page=1&per=" +
      per +
      "&start_date=" +
      dateStart +
      "&end_date=" +
      dateEnd +
      "&use_keyset_paging=true";

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let invoicesData = JSON.parse(JSON.stringify(response.data));
        let invoicesCount = invoicesData.pagination.count;
        setCount(invoicesCount);
        setCreditNotes(invoicesData.invoices);

        // Reset keyset pagination for date filter
        setNextCursor(invoicesData.next_cursor);
        setPrevCursor(invoicesData.prev_cursor);
        setHasNext(invoicesData.has_next);
        setHasPrev(invoicesData.has_prev);
        setCurrentCursor(null);
        setCurrentPage(1);

        let numPages = Math.ceil(invoicesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("filter CreditNotes err = " + err.message));
  };

  const downloadExcelCreditNotes = async () => {
    try {
      const formattedStartDate = startDate.toISOString().split("T")[0];
      const formattedEndDate = endDate.toISOString().split("T")[0];

      var accessToken = localStorage.getItem("strutspos_access_token");
      var apiURL =
        apiBaseURL +
        "/invoices/download?document_type=credit_note&page=1&per=" +
        1000 +
        "&start_date=" +
        formattedStartDate +
        "&end_date=" +
        formattedEndDate +
        "&search=" +
        searchTerm;

      const response = await axios.get(apiURL, {
        responseType: "blob",
        headers: {
          "x-strutspos-token": accessToken,
          "x-strutspos-application": "user",
        },
      });

      const blob = new Blob([response.data]);

      // Get the filename from the Content-Disposition header
      console.log(response.headers);
      const contentDisposition = response.headers["content-disposition"];
      console.log(contentDisposition);

      const parts = contentDisposition.split("=");
      // Extract the second parameter as the filename
      const filename = parts[1].trim();
      console.log(filename);

      // Create a temporary anchor element to trigger the download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const updateStartDate = (date) => {
    setStartDate(date);

    const formattedStartDate = date.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    // Filter invoices based on start and end dates
    dateFilterCreditNotes(formattedStartDate, formattedEndDate);
  };

  const updateEndDate = (date) => {
    setEndDate(date);

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = date.toISOString().split("T")[0];

    // Filter invoices based on start and end dates
    dateFilterCreditNotes(formattedStartDate, formattedEndDate);
  };

  const handleScroll = (event) => {
    const container = event.target;
    const scrollAmount = event.deltaY;
    container.scrollTo({
      top: 0,
      left: container.scrollLeft + scrollAmount,
      behavior: "smooth",
    });
  };

  const handlePerChange = (newPer) => {
    setPer(newPer);
    setCurrentPage(1);
    setCurrentCursor(null);

    // Reload data with new per value
    let accessToken = localStorage.getItem("strutspos_access_token");
    let url =
      apiBaseURL +
      "/invoices?document_type=credit_note&per=" +
      newPer +
      "&use_keyset_paging=true";

    // Add current filters if they exist
    if (searchTerm) {
      url += "&search=" + searchTerm;
    }

    if (startDate && endDate) {
      const formattedStartDate = startDate.toISOString().split("T")[0];
      const formattedEndDate = endDate.toISOString().split("T")[0];
      url +=
        "&start_date=" + formattedStartDate + "&end_date=" + formattedEndDate;
    }

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let invoicesData = JSON.parse(JSON.stringify(response.data));
        let invoicesCount = invoicesData.pagination.count;
        setCount(invoicesCount);
        setCreditNotes(invoicesData.invoices);

        // Reset keyset pagination
        setNextCursor(invoicesData.next_cursor);
        setPrevCursor(invoicesData.prev_cursor);
        setHasNext(invoicesData.has_next);
        setHasPrev(invoicesData.has_prev);
        setCurrentCursor(null);

        let numPages = Math.ceil(invoicesCount / newPer);
        setPageCount(numPages);
      })
      .catch((err) => console.error("handlePerChange err = " + err.message));
  };

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Credit Notes Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">Credit Notes</h1>
              <p className="dashboard-subtitle">
                Manage and view all credit notes ({count.toLocaleString()}{" "}
                total)
              </p>
            </div>
          </div>

          {/* Filters and Controls Card */}
          <div className="filters-card-modern">
            <div className="filters-header">
              <h3>Filters & Controls</h3>
            </div>

            <div className="filters-grid">
              <div className="filter-group">
                <label className="filter-label">From Date:</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => updateStartDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="modern-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">To Date:</label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => updateEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="modern-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Search:</label>
                <input
                  className="modern-input"
                  type="text"
                  placeholder="Search credit notes..."
                  name="search"
                  onChange={(e) => searchCreditNotes(e.target.value)}
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Records per page:</label>
                <select
                  className="modern-input"
                  value={per}
                  onChange={(e) => handlePerChange(parseInt(e.target.value))}
                >
                  <option value={5}>5 records</option>
                  <option value={8}>8 records</option>
                  <option value={10}>10 records</option>
                  <option value={20}>20 records</option>
                  <option value={50}>50 records</option>
                  <option value={100}>100 records</option>
                </select>
              </div>

              <div className="filter-group">
                <button
                  className="modern-button primary"
                  onClick={() => downloadExcelCreditNotes()}
                >
                  📊 Export Excel
                </button>
              </div>
            </div>
          </div>

          {/* Credit Notes Table Card */}
          <div className="table-card-modern">
            <div className="table-header">
              <h3>Credit Notes List</h3>
              <span className="table-count">{count} credit notes</span>
            </div>

            <div className="table-container-modern" onWheel={handleScroll}>
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>VoucherID#</th>
                    <th>Customer Name</th>
                    <th>Customer PIN</th>
                    <th>ETIMS Signature</th>
                    <th>VAT</th>
                    <th>Grand Total</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((invoice) => (
                    <tr key={invoice.id}>
                      <td className="font-mono">{invoice.invoice_number}</td>
                      <td>{invoice.customer_name}</td>
                      <td>{invoice.customer_tin}</td>
                      <td className="truncate">
                        {invoice.etims_receipt_signature}
                      </td>
                      <td className="text-right">
                        {(invoice?.vat || 0).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right font-semibold">
                        {(invoice.grand_total || 0).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>{invoice.created_at.substring(0, 10)}</td>
                      <td>
                        <Link
                          to={{ pathname: `/credit-notes/${invoice.id}` }}
                          className="modern-button small primary"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="pagination-container-modern">
              <div className="keyset-pagination">
                <button
                  className={`modern-button ${
                    !hasPrev ? "disabled" : "secondary"
                  }`}
                  onClick={() => handlePageClick("prev")}
                  disabled={!hasPrev}
                >
                  ← Previous
                </button>

                <span className="pagination-info">
                  Page {currentPage} of {pageCount} ({count.toLocaleString()}{" "}
                  total)
                </span>

                <button
                  className={`modern-button ${
                    !hasNext ? "disabled" : "secondary"
                  }`}
                  onClick={() => handlePageClick("next")}
                  disabled={!hasNext}
                >
                  Next →
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CreditNotes;
